import { CHART_COLOR_PALLETTE } from 'utils/constants';
import { ICellRendererParams, ICurrencyFormat } from 'utils/types';
import {
  cellCurrencyRendererFramework,
  varianceCurrencyCellRendererFramework,
} from '../TableComponents';

export const useTableData = (
  columnTitles: string[],
  columnDateLabels: string[],
  format: ICurrencyFormat
) => {
  if (!columnTitles.length) {
    return [];
  }
  const regularCellRenderer = (params: ICellRendererParams) =>
    cellCurrencyRendererFramework(params, format);
  const varianceCellRenderer = (params: ICellRendererParams) =>
    varianceCurrencyCellRendererFramework(params, format);
  if (columnTitles.length === 2) {
    return [
      {
        headerName: '',
        field: 'title',
        width: 252,
        headerComponentParams: { hideIcon: true },
        sortable: true,
      },
      {
        headerName: columnTitles[0],
        headerGroupComponent: 'customHeaderGroupComponent',
        children: [
          {
            headerName: columnDateLabels[0],
            field: 'category1CurrYear',
            headerComponentParams: {
              color: CHART_COLOR_PALLETTE[0],
              align: 'right',
            },
            sortable: true,
            cellRendererFramework: regularCellRenderer,
          },
          {
            headerName: columnDateLabels[1],
            field: 'category1PrevYear',
            headerComponentParams: {
              color: CHART_COLOR_PALLETTE[1],
              align: 'right',
            },
            sortable: true,
            cellRendererFramework: regularCellRenderer,
          },
          {
            headerName: 'Variance',
            field: 'category1Variance',
            cellRendererFramework: varianceCellRenderer,
            headerComponentParams: { hideIcon: true, align: 'right' },
            sortable: true,
          },
        ],
      },
      {
        headerName: '',
        field: 'emptySpace',
        width: 48,
      },
      {
        headerName: columnTitles[1],
        headerGroupComponent: 'customHeaderGroupComponent',
        headerClass: 'capex-group',
        children: [
          {
            headerName: columnDateLabels[0],
            field: 'category2CurrYear',
            headerComponentParams: {
              color: CHART_COLOR_PALLETTE[0],
              align: 'right',
            },
            sortable: true,
            cellRendererFramework: regularCellRenderer,
          },
          {
            headerName: columnDateLabels[1],
            field: 'category2PrevYear',
            headerComponentParams: {
              color: CHART_COLOR_PALLETTE[1],
              align: 'right',
            },
            sortable: true,
            cellRendererFramework: regularCellRenderer,
          },
          {
            headerName: 'VARIANCE',
            field: 'category2Variance',
            cellRendererFramework: varianceCellRenderer,
            sortable: true,
            headerComponentParams: { hideIcon: true, align: 'right' },
          },
        ],
      },
      {
        headerName: '',
        field: 'emptySpace',
        width: 48,
      },
      {
        headerName: 'TOTAL',
        headerGroupComponent: 'customHeaderGroupComponent',

        children: [
          {
            headerName: columnDateLabels[0],
            field: 'totalCurrYear',
            headerComponentParams: {
              color: CHART_COLOR_PALLETTE[0],
              align: 'right',
            },
            sortable: true,
            cellRendererFramework: regularCellRenderer,
          },
          {
            headerName: columnDateLabels[1],
            field: 'totalPrevYear',
            headerComponentParams: {
              color: CHART_COLOR_PALLETTE[1],
              align: 'right',
            },
            sortable: true,
            cellRendererFramework: regularCellRenderer,
          },
          {
            headerName: 'VARIANCE',
            field: 'totalVariance',
            cellRendererFramework: varianceCellRenderer,
            sortable: true,
            headerComponentParams: { hideIcon: true, align: 'right' },
          },
        ],
      },
    ];
  }
  return [
    {
      headerName: '',
      field: 'title',
      width: 252,
      sortable: true,
      headerComponentParams: { hideIcon: true },
    },
    {
      headerName: columnTitles[0],
      headerGroupComponent: 'customHeaderGroupComponent',
      children: [
        {
          headerName: columnDateLabels[0],
          field: 'category1CurrYear',
          headerComponentParams: {
            color: CHART_COLOR_PALLETTE[0],
            align: 'right',
          },
          sortable: true,
          cellRendererFramework: regularCellRenderer,
        },
        {
          headerName: columnDateLabels[1],
          field: 'category1PrevYear',
          headerComponentParams: {
            color: CHART_COLOR_PALLETTE[1],
            align: 'right',
          },
          sortable: true,
          cellRendererFramework: regularCellRenderer,
        },
        {
          headerName: 'Variance',
          field: 'category1Variance',
          cellRendererFramework: varianceCellRenderer,
          sortable: true,
          headerComponentParams: { hideIcon: true, align: 'right' },
        },
      ],
    },
  ];
};
